<script setup lang="ts">
// Vendor
import { object, string } from "zod";
import type { RouteLocationRaw } from "vue-router";

// Constants
import { SALESFORCE_FORM_TYPE } from "@citizenm/salesforce/constants/form";

// Components
// TODO: remove this import when legacy FormRow component is removed
import FormRow from "@citizenm/form/components/FormRow.vue";

const { thankYouPage } = defineProps<{
  thankYouPage?: RouteLocationRaw;
}>();

const { handleSubmit, state } = useSalesforceForm(
  SALESFORCE_FORM_TYPE.WebToCase,
  thankYouPage,
);
const { t } = useI18n();

const validationSchema = toTypedSchema(
  object({
    name: string({
      required_error: t("website.form.requiredValue"),
    }),
    email: string({
      required_error: t("website.form.requiredValue"),
    }).email(t("website.form.error.email_invalid")),
    Request__c: string({
      required_error: t("website.form.requiredValue"),
    }),
    description: string().optional(),
    CreatedFromPrivacyWebform__c: string().default("1"),
  }),
);

const privacyRequestOptions = [
  {
    label: t("website.form.privacy.request_options.option_1"),
    value: t("website.form.privacy.request_options.option_1"),
  },
  {
    label: t("website.form.privacy.request_options.option_2"),
    value: t("website.form.privacy.request_options.option_2"),
  },
  {
    label: t("website.form.privacy.request_options.option_3"),
    value: t("website.form.privacy.request_options.option_3"),
  },
  {
    label: t("website.form.privacy.request_options.option_4"),
    value: t("website.form.privacy.request_options.option_4"),
  },
  {
    label: t("website.form.privacy.request_options.option_5"),
    value: t("website.form.privacy.request_options.option_5"),
  },
  {
    label: t("website.form.privacy.request_options.option_6"),
    value: t("website.form.privacy.request_options.option_6"),
  },
];
</script>

<template>
  <BaseForm
    :state="state"
    :validation-schema="validationSchema"
    @submit="handleSubmit"
  >
    <FormRow template="1fr 1fr">
      <FormControl :label="t('website.form.full_name')" name="name">
        <FormText />
      </FormControl>
      <FormControl :label="t('website.form.email')" name="email">
        <FormText />
      </FormControl>
    </FormRow>
    <FormRow template="1fr 1fr">
      <FormControl
        :label="t('website.form.privacy.request.label')"
        name="Request__c"
      >
        <FormSelect
          :options="privacyRequestOptions"
          :placeholder="t('website.form.privacy.request.placeholder')"
        />
      </FormControl>
    </FormRow>
    <FormRow>
      <FormControl :label="t('website.form.notes')" name="description">
        <FormTextarea auto-resize />
      </FormControl>
    </FormRow>
  </BaseForm>
</template>
